module.exports = __webpack_public_path__ + "static/img/product.632b83c9.jpg";